<div class="py-3 summary-box" [ngClass]="{ 'summary-box--closed': !summaryOpened }">
  <div class="container-fluid">
    <div (click)="toggleSummary()" class="text-left cursor-pointer">
      <img draggable="false" class="mr-2 toggler" src="./assets/img/ic-arrow-grey-black.svg" alt="arrow" />
      <b>{{ 'ProjectChanges.showSharedSummary' | translate }}</b>
    </div>
    <summary-list *ngIf="summary && summaryOpened" [items]="displayedSummaryConfig?.items" />
  </div>
</div>
